import CatzumComponent from "./CatzumComponent/CatzumComponent.vue";
import ButtonComponent from "./ButtonComponent/ButtonComponent.vue";
import PrimeVue from "primevue/config";
import Button from 'primevue/button';
import { createApp } from "vue";
import App from "./App.vue";


const app = createApp(App);
app.use(PrimeVue)
app.component('Button', Button)

const btn = createApp(ButtonComponent)
btn.use(PrimeVue);
btn.component('Button', Button)
export { CatzumComponent, btn };
